/**
 * Check if user requires email validaiton with proper fallback for older accounts.
 */
export const userRequiresEmailValidation = (user) => {
    return user.requiresEmailValidation === true;
};
